import Vue from 'vue'
import Acl from 'vue-browser-acl'
import store from '@/store'

const user = () => {
  return store.state.auth.user
}

const SUBJECT = 'exploitation'

Vue.use(Acl, user, (acl) => {
  // on définit tous les "subjects" à la même valeur
  acl.subjectMapper = s => SUBJECT

  acl.rule('admin', (user) => {
    return user.role === 'admin'
  })

  acl.rule('create-exploitation', (user) => {
    return user.role !== 'exploit'
  })

  acl.rule('delete-exploitation', SUBJECT, (user, exploitation) => {
    return user.role === 'admin' || exploitation.id_owner === user.id_user
  })

  acl.rule('edit-exploitation', SUBJECT, (user) => {
    let exploitation = (store.state.exploitation || {}).information
    return exploitation == null || user.role === 'admin' || exploitation.id_owner === user.id_user || exploitation.id_exploitant === user.id_user
  })

  acl.rule('simu-clim', (user) => {
    return user.simu_clim === true
  })
})
